<template>
  <NewVps></NewVps>
</template>

<script>
import NewVps from "@/components/main/vps/new/component.vue";

export default {
  components: {
    NewVps
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},

  methods: {}
};
</script>
